import { render, staticRenderFns } from "./settings-info.vue?vue&type=template&id=53c6deea&"
import script from "./settings-info.vue?vue&type=script&lang=js&"
export * from "./settings-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports